import {
  AfterViewInit,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {Task, TaskControllerService} from "../../../api";
import  {PermissionService} from "../../../services/permission/permission.service";
import {MatSort, MatSortHeader} from "@angular/material/sort";
import {ActivatedRoute, Router} from "@angular/router";
import {TaskDetailsService} from "../../../services/tasks/task-details.service";
import {StateConfigService} from "../../../services/state/state-config.service";
import {MatDialog} from "@angular/material/dialog";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {faCircleInfo, faClipboardCheck, faEllipsisVertical} from "@fortawesome/pro-solid-svg-icons";
import {BicButtonComponent} from "@buildinginformationcloud/bic-ui-components";
import {EmptyStateComponent} from "../../util/design/empty-state/empty-state.component";
import {TaskDeleteDialog} from "../task-detail/task-detail.component";
import {DatePipe, NgClass} from "@angular/common";
import {MatButton, MatIconButton} from "@angular/material/button";
import {PriorityPipe} from "../../../pipes/priority.pipe";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {TaskStatePipe} from "../../../pipes/task-state.pipe";
import {TaskSseService} from "../../../services/tasks/task-sse.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import PriorityEnum = Task.PriorityEnum;
import {TooltipDirective} from "@buildinginformationcloud/bic-ui-components";

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgClass,
    MatHeaderCellDef,
    MatColumnDef,
    MatCellDef,
    MatHeaderCell,
    MatSort,
    MatTable,
    MatButton,
    MatSortHeader,
    PriorityPipe,
    MatCell,
    DatePipe,
    MatIconButton,
    FaIconComponent,
    BicButtonComponent,
    EmptyStateComponent,
    MatHeaderRowDef,
    MatRowDef,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatMenuContent,
    MatHeaderRow,
    MatRow,
    TaskStatePipe,
    TooltipDirective
  ]
})
export class TaskListComponent implements OnInit, AfterViewInit {
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private taskControllerService = inject(TaskControllerService);
  private activatedRoute = inject(ActivatedRoute);
  private taskDetailService = inject(TaskDetailsService);
  private stateService = inject(StateConfigService);
  private taskSseService = inject(TaskSseService);
  private destroyRef = inject(DestroyRef);
  protected permissionService = inject(PermissionService);

  @Input() projectId: number | undefined;
  @Output() importBCFClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() exportBCFClicked: EventEmitter<Task> = new EventEmitter<Task>();
  tasks: Task[] = [];

  /**
   * Displayed Columns for MatTable of Tasks
   */
  displayedColumns: string[] = ['title', 'prio', 'projectName', 'deadline', 'state', 'createdBy', 'people', 'date', 'actions'];

  /**
   * Data Source for MatTable of Tasks
   */
  dataSource!: Task[];//MatTableDataSource<Task>;

  /**
   * Paginator Child from MatPaginator
   */
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  /**
   * Sort Child for MatTable
   */
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('tasksTbSort') tasksTbSort = new MatSort();

  priorityEnum: typeof PriorityEnum = PriorityEnum;
  task_length: number = 0;
  default_page_size: number = 10;

  ngOnInit(): void {
    this.taskControllerService.getTasks(this.stateService.getProjectIdOrUndefined(), this.stateService.getOrganisationIdOrUndefined(), this.stateService.isPersonal).subscribe(tasks => {
      this.tasks = tasks;
      this.dataSource = this.tasks;

      if (!this.stateService.getProject()) {
        this.displayedColumns = ['title', 'prio', 'projectName', 'deadline', 'state', 'createdBy', 'people', 'date', 'project', 'actions']
      }

      this.task_length = this.tasks.length
    });

    const projectId = this.stateService.getProjectIdOrUndefined();
    if (projectId) {
      this.taskSseService.subscribeToProject(projectId);
      this.taskSseService.taskEvents$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
        if (event.type === 'TASK_CREATED') {
          this.tasks = [...this.tasks, event.data];
        } else if (event.type === 'TASK_UPDATED') {
          this.tasks = this.tasks.map(t => t.id === event.data.id ? event.data : t);
        } else if (event.type === 'TASK_DELETED') {
          this.tasks = this.tasks.filter(t => t.id !== (event.data as unknown as string));
        }
        this.dataSource = this.tasks;
        this.task_length = this.tasks.length;
      });
    }

    this.taskDetailService.currentTaskChanged.subscribe(task => {
      this.refreshList();
    });
  }

  refreshList() {
    this.taskControllerService.getTasks(this.stateService.getProject()?.id, this.stateService.selectedOrganisation?.id, this.stateService.isPersonal).subscribe(tasks => {
      this.tasks = tasks;
      this.dataSource = this.tasks;
      this.task_length = this.tasks.length;

      //this.dataSource.paginator = this.paginator;
      //this.dataSource.sort = this.tasksTbSort;
    })
  }

  ngAfterViewInit() {
    this.taskControllerService.getTasks(this.stateService.getProject()?.id, this.stateService.selectedOrganisation?.id, this.stateService.isPersonal).subscribe(tasks => {
      this.tasks = tasks;
      this.dataSource = this.tasks
      //this.dataSource.data = this.dataSource.data.concat(this.tasks.slice(this.default_page_size, this.tasks.length));

      this.task_length = this.tasks.length;

      //this.dataSource.paginator = this.paginator;
      //this.dataSource.sort = this.tasksTbSort;
      /*this.dataSource.sortingDataAccessor = (row: Task, columnName: string): string => {
        if (columnName == "prio") {
          return row.priority?.toString() ?? "";
        } else if (columnName == "projectName") {
          return  "";
        } else if (columnName == "date") {
          return row.markup?.topic?.creationDate?.toString() ?? "";
        } else if (columnName == "createdBy") {
          return row.markup?.topic?.creationUser?.firstName ?? row.markup?.topic?.creationAuthor ?? "";
        }
        var columnValue = row[columnName as keyof Task] as string;
        return columnValue;
      }*/
    })
  }

  /**
   * Applies filter of searchbar to datasource
   * @param event data from searchbar
   */
  /*applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }*/

  selectTask(task?: Task, create: boolean = false) {
    this.taskDetailService.setOpenedTask(task)


    // if (create) {
    //   this.router.navigate(['/tasks/create']);
    // }
    // if (task) {
    //   this.router.navigate(['/tasks/', task.id]);
    // }

  }

  openDeleteDialog(task: Task) {
    let dialogRef = this.dialog.open(TaskDeleteDialog, {
      panelClass:"rounded-corners-dialog",
      data: {task: task}
    });

  }

  createNewTask() {
    this.taskDetailService.setOpenedTask(undefined);
  }

  protected readonly faEllipsisVertical = faEllipsisVertical;
  protected readonly faCircleInfo = faCircleInfo;
  protected readonly faClipboardCheck = faClipboardCheck;
}
